// Lógica pura (sin React/Firebase) para aplicar, sobre un componentConfig
// base de una sección de la web pública, las traducciones guardadas para
// un idioma — si un campo (o un ítem de un arreglo repetible tipo
// inputsArray) no tiene traducción para ese idioma, o está vacía, se deja
// el valor base (español) tal cual.
//
// No necesita conocer el esquema de la sección (qué campos son texto o
// foto) — la tabla de traducción del admin (TraduccionesSeccionTable) ya
// se encarga de solo guardar overrides para los campos que corresponde;
// acá solo se recorre lo que de verdad llegó guardado.

function valorTraducido(valorBase, entradaTraduccion, idioma) {
  if (!entradaTraduccion) return valorBase;
  const traducido = entradaTraduccion[idioma];
  return traducido !== undefined && traducido !== null && traducido !== ""
    ? traducido
    : valorBase;
}

// traduccionesSeccion shape:
// {
//   [campoSimple]: { [idioma]: "texto o URL" },
//   [campoRepetible]: { [indexArray]: { [subCampo]: { [idioma]: "..." } } },
// }
export function resolverTraduccionesSeccion(
  componentConfig,
  traduccionesSeccion,
  idioma
) {
  if (!componentConfig) return componentConfig;
  if (!traduccionesSeccion || !idioma || idioma === "es") {
    return componentConfig;
  }

  const resultado = { ...componentConfig };

  Object.keys(traduccionesSeccion).forEach((campo) => {
    const valorBase = componentConfig[campo];
    const entradaCampo = traduccionesSeccion[campo];

    if (valorBase && typeof valorBase === "object") {
      // Campo repetible (inputsArray, ej. items del menú del header): según
      // cómo haya quedado guardado en Firebase puede llegar como arreglo
      // (índices 0..n-1 seguidos) u objeto con llaves dispersas si se borró
      // algún ítem — se recorre por llave en vez de asumir un arreglo, para
      // que funcione igual en ambos casos.
      const esArray = Array.isArray(valorBase);
      const resultadoCampo = esArray ? [...valorBase] : { ...valorBase };

      Object.keys(valorBase).forEach((indexArray) => {
        const entradaItem = entradaCampo && entradaCampo[indexArray];
        if (!entradaItem) return;

        const item = valorBase[indexArray];
        const itemTraducido = { ...item };
        Object.keys(entradaItem).forEach((subCampo) => {
          itemTraducido[subCampo] = valorTraducido(
            item[subCampo],
            entradaItem[subCampo],
            idioma
          );
        });
        resultadoCampo[indexArray] = itemTraducido;
      });

      resultado[campo] = resultadoCampo;
    } else {
      resultado[campo] = valorTraducido(valorBase, entradaCampo, idioma);
    }
  });

  return resultado;
}
